export function getFirebaseErrorMessage(error) {
    // console.log("Firebase Error:", error);

    switch (error?.code) {
        // User authentication
        case 'auth/user-not-found':
            return 'User not found. Please check your email or sign up.';

        // Password issue
        case 'auth/wrong-password':
            return 'Incorrect password. Please try again.';

        case 'auth/weak-password':
            return 'Password should be at least 6 characters long.';

        // Email conflict
        case 'auth/email-already-in-use':
            return 'Email already in use. Please use a different email.';

        // Claims size
        case 'auth/claims-too-large':
            return 'The claims payload provided is too large. Please reduce the size.';

        // Email exists
        case 'auth/email-already-exists':
            return 'The email address is already in use by another account.';

        // Token expired
        case 'auth/id-token-expired':
            return 'Your session has expired. Please sign in again.';

        // Token revoked
        case 'auth/id-token-revoked':
            return 'Your session has been revoked. Please sign in again.';

        // Permission error
        case 'auth/insufficient-permission':
            return "You don't have permission to perform this action.";

        // Internal error
        case 'auth/internal-error':
            return 'An internal error occurred. Please try again later.';

        // Invalid input
        case 'auth/invalid-argument':
            return 'Invalid information provided. Please check your inputs.';

        // Claims invalid
        case 'auth/invalid-claims':
            return 'Invalid custom claims provided.';

        // URL invalid
        case 'auth/invalid-continue-uri':
            return 'The continue URL is invalid.';

        // Time invalid
        case 'auth/invalid-creation-time':
            return 'Invalid account creation time.';

        // Credential issue
        case 'auth/invalid-credential':
            return 'The provided credential is invalid or has expired.';

        // Status invalid
        case 'auth/invalid-disabled-field':
            return 'Invalid account status.';

        // Name invalid
        case 'auth/invalid-display-name':
            return 'Invalid display name. Please provide a valid name.';

        // Domain issue
        case 'auth/invalid-dynamic-link-domain':
            return 'Invalid dynamic link domain.';

        // Email format
        case 'auth/invalid-email':
            return 'The email address is invalid. Please enter a valid email.';

        // Verification issue
        case 'auth/invalid-email-verified':
            return 'Invalid email verification status.';

        // Hash algorithm
        case 'auth/invalid-hash-algorithm':
            return 'Invalid hash algorithm.';

        // Block size
        case 'auth/invalid-hash-block-size':
            return 'Invalid hash block size.';

        // Key length
        case 'auth/invalid-hash-derived-key-length':
            return 'Invalid hash key length.';

        // Hash key
        case 'auth/invalid-hash-key':
            return 'Invalid hash key.';

        // Memory cost
        case 'auth/invalid-hash-memory-cost':
            return 'Invalid hash memory cost.';

        // Parallelization issue
        case 'auth/invalid-hash-parallelization':
            return 'Invalid hash parallelization.';

        // Hash rounds
        case 'auth/invalid-hash-rounds':
            return 'Invalid number of hash rounds.';

        // Salt separator
        case 'auth/invalid-hash-salt-separator':
            return 'Invalid salt separator.';

        // Token invalid
        case 'auth/invalid-id-token':
            return 'Invalid ID token. Please sign in again.';

        // Sign-in time
        case 'auth/invalid-last-sign-in-time':
            return 'Invalid last sign-in time.';

        // Page token
        case 'auth/invalid-page-token':
            return 'Invalid page token.';

        // Password format
        case 'auth/invalid-password':
            return 'Invalid password. Password should be at least 6 characters.';

        // Password hash
        case 'auth/invalid-password-hash':
            return 'Invalid password hash.';

        // Password salt
        case 'auth/invalid-password-salt':
            return 'Invalid password salt.';

        // Phone format
        case 'auth/invalid-phone-number':
            return 'Invalid phone number. Please enter a valid phone number.';

        // Photo URL
        case 'auth/invalid-photo-url':
            return 'Invalid profile photo URL.';

        // Provider data
        case 'auth/invalid-provider-data':
            return 'Invalid provider data.';

        // Provider ID
        case 'auth/invalid-provider-id':
            return 'Invalid provider ID.';

        // OAuth response
        case 'auth/invalid-oauth-responsetype':
            return 'Invalid OAuth response type.';

        // Cookie duration
        case 'auth/invalid-session-cookie-duration':
            return 'Invalid session cookie duration.';

        // User ID
        case 'auth/invalid-uid':
            return 'Invalid user ID.';

        // Import issue
        case 'auth/invalid-user-import':
            return 'Invalid user data for import.';

        // User limit
        case 'auth/maximum-user-count-exceeded':
            return 'Maximum number of users exceeded.';

        // Android package
        case 'auth/missing-android-pkg-name':
            return 'Missing Android package name.';

        // Missing Email ID
        case 'auth/missing-email':
            return 'Link is invalid or expired. Please try logging in again.';

        // Continue URL
        case 'auth/missing-continue-uri':
            return 'Missing continue URL.';

        // Hash algorithm
        case 'auth/missing-hash-algorithm':
            return 'Missing hash algorithm.';

        // iOS bundle
        case 'auth/missing-ios-bundle-id':
            return 'Missing iOS bundle ID.';

        // UID missing
        case 'auth/missing-uid':
            return 'Missing user ID.';

        // OAuth secret
        case 'auth/missing-oauth-client-secret':
            return 'Missing OAuth client secret.';

        // Method disallowed
        case 'auth/operation-not-allowed':
            return 'This sign-in method is not allowed. Please contact support.';

        // Phone exists
        case 'auth/phone-number-already-exists':
            return 'This phone number is already in use by another account.';

        // Project missing
        case 'auth/project-not-found':
            return 'Project not found. Please check your configuration.';

        // Reserved claims
        case 'auth/reserved-claims':
            return 'Reserved claims are being used.';

        // Cookie expired
        case 'auth/session-cookie-expired':
            return 'Your session has expired. Please sign in again.';

        // Cookie revoked
        case 'auth/session-cookie-revoked':
            return 'Your session has been revoked. Please sign in again.';

        // Rate limit
        case 'auth/too-many-requests':
            return 'Too many requests. Please try again later.';

        // UID exists
        case 'auth/uid-already-exists':
            return 'User ID already exists.';

        // Unauthorized URL
        case 'auth/unauthorized-continue-uri':
            return 'Unauthorized continue URL.';

        // Expired action code
        case 'auth/expired-action-code':
            return 'Reset link has expired. Please request a new one.';

        // Invalid action code
        case 'auth/invalid-action-code':
            return 'Invalid reset link. Please request a new one.';

        // Default fallback
        default:
            return 'An unknown error occurred. Please try again.';
    }
}
